import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change } from 'redux-form'
import compose from 'recompose/compose'

import translate from '@/i18n/translate'
import { goToPage as goToPageAction } from '@/state/actions/routes'
import {
  crudCreate as crudCreateAction,
  crudUpdate as crudUpdateAction,
} from '@/state/actions/data'

import { Card } from '@/ui/Card'
import Button from '@/ui/Button/Button'
import { Container, Row, Column, Cell, Flex } from '@/ui/Element'

import { InputField, ImageInput } from '@/ui/Input'
import ImageField from '@/ui/Data/ImageField'

class EditComponents extends Component {
  renderImage = props => (
    <ImageInput
      {...props}
      theme={this.props.theme}
      source="image"
      label="Image"
      accept="image/*"
      placeholder={
        <div>
          <span>
            Image, JPG, PNG<br />min. size 360 x 360 px
          </span>
          <p>DROP IMAGE TO UPLOAD</p>
        </div>
      }
    >
      <ImageField source="src" title="title" />
    </ImageInput>
  )

  saveComponent = record => {
    if (this.props.id) {
      this.props.crudUpdate('components', this.props.id, record, this.props.initialValues, false, {
        message: `${record.title || this.props.initialValues.title} updated.`,
      })
    } else {
      this.props.crudCreate('components', record, false, {
        message: `${record.title || this.props.initialValues.title} created.`,
      })
    }
  }

  goBack = () => {
    this.props.dispatch(this.props.goToPage(this.props.currentRouteData.parent))
  }

  render() {
    const {
      theme,
      handleSubmit,
      submitting,
      // translate,
      // me,
      // ...rest
    } = this.props
    const disabled = !!this.props.id

    return (
      <Container>
        <Column>
          <form className="form" onSubmit={handleSubmit(this.saveComponent)}>
            <Card classes={['v-padding-large', 'colored-card']}>
              <Row>
                <Cell>
                  <Field
                    name="title"
                    labelText="Component Name:"
                    component={InputField}
                    placeholder="Component name"
                    id="title"
                  />
                  <Field
                    name="identifier"
                    labelText="Component Identifier:"
                    component={InputField}
                    placeholder="Component identifier (should not be changed).."
                    id="identifier"
                    disabled={disabled}
                  />
                  <Field
                    name="code"
                    labelText="Inky code:"
                    className={theme['text-mono']}
                    style={{ whiteSpace: 'pre' }}
                    component={InputField}
                    multiLine
                    autoCorrect="off"
                    placeholder="<Inky code />"
                    id="code"
                  />
                </Cell>
              </Row>
            </Card>
            <Flex horz="right" classes={['top-margin']}>
              <Button
                theme={theme}
                styles="right-margin"
                disabled={submitting}
                onClick={this.goBack}
              >
                Cancel
              </Button>
              <Button
                theme={theme}
                type="submit"
                classes={['secondary']}
                styles="h-padding-large"
                disabled={submitting}
              >
                Save
              </Button>
            </Flex>
          </form>
        </Column>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  const componentId = state.location.payload.id
  return {
    id: componentId,
    initialValues: state.rest.components.data[componentId],
    isLoading: state.rest.loading > 0,
  }
}

const enhance = compose(
  connect(mapStateToProps, {
    goToPage: goToPageAction,
    crudUpdate: crudUpdateAction,
    crudCreate: crudCreateAction,
    change: change,
  }),
  translate,
  reduxForm({
    form: 'editComponents',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      ;['full_name', 'position', 'email', 'phone'].forEach(field => {
        if (!values[field]) errors[field] = translate('i18n.validation.required')
      })
      return errors
    },
  }),
)

export default enhance(EditComponents)



// WEBPACK FOOTER //
// ./view/Components/editComponents.js